export const name = 'gzIcon';

/**
 * @ngdoc directive
 * @name gazelle.components.icon.directive:gzIcon
 *
 * @param {string=} icon Specifies the icon set and the icon in that set to use.
 *
 * @description
 * `<gz-icon>` is a widget that will display an md-icon.  Based on the icon set 'fa', 'md', 'hp', 'png' it will load the appropriate
 *  icon set and use the name to render the icon.
 *
 * @usage
 * ```html
 * <gz-icon icon='set:name'></gz-icon>
 * ```
 */
export default function gzIcon($log, $compile) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var directive = {
    restrict: 'EA',
    scope: {
      icon: '@'
    },
    link: gzIconLink,
  };

  return directive;


  //////////////////////
  // Private functions

  function gzIconLink(scope, element, attrs) {
    // $log.debug('gzIconLink' + attrs.icon);
    let type = '';
    let split = attrs.icon.split(':');
    let iconName = split[1];
    //shudder - yucky case:
    switch(split[0]) {
      case 'md':
        type = 'md-font-set="material-icons"';
        break;
      case 'fa':
        type = 'md-font-set="fa"';
        break;
      case 'hp':
        type = 'md-font-set=""';
        break;
      default:
        $log.warn('unknown icon set specified: ' + split[0]);
    }
    let html = `<md-icon ${type}>${iconName}</md-icon>`;
    let e = $compile(html)(scope);
    element.replaceWith(e);
  }
} //gzIcon



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/icon/icon.directive.js